//src/auth/Stripe.ts
import initializeStripe from "./InitializeStripe";

export async function createCheckoutSession(sessionId: string) {
    const stripe = await initializeStripe();
    if (stripe) {
        const { error } = await stripe.redirectToCheckout({sessionId: sessionId,});
        if (error) console.error(error);
    }
}
